import React from "react";
import Contact from "@/pages/Contact";
import SEO from "@/utils/SEO";
import AppLayout from "@/layouts/AppLayout";
import styled from "styled-components";

const SinglePage: React.FC<SinglePageProps> = (props) => {

    if (props.page.data.slug === "contact") {
        return <Contact />;
    }

    return (
        <AppLayout>
            <section>
                <SEO seo={props.page.data.seo} />
                {props.page.data.image && (
                    <img
                        className="w-full object-cover max-h-[600px]"
                        src={props.page.data.image}
                    />
                )}
                <div className="container m-auto my-8 px-2">
                    <div className="text-3xl lg:text-5xl text-center text-primary mb-8">
                        {props.page.data.name}
                    </div>

                    <div
                        dangerouslySetInnerHTML={{
                            __html: props.page.data.content,
                        }}
                    />
                </div>
            </section>
        </AppLayout>
    );
};

export default SinglePage;

interface MenuItem {
    title: string;
    url: string;
    target: string;
    child: MenuItem[];
}

interface PageContent {
    content: string;
    description: string;
    image: string | null;
    name: string;
    seo: {
        description: string;
        metaKeywords: string | null;
        title: string;
    };
    slug: string;
}

interface SocialLink {
    name: string;
    link: string;
    icon: string;
    image: string | null;
}

interface SinglePageProps {
    copyright: string;
    data: any[];
    errors: Record<string, any>;
    favicon: string;
    headerLogo1: string;
    isAuth: boolean;
    member: any | null;
    menus: {
        footer: MenuItem[];
        header: MenuItem[];
    };
    message: string | null;
    page: {
        data: PageContent;
    };
    social: SocialLink[];
}
